module.exports = __webpack_public_path__ + "img/128.6.458c82ec.png";